/* import __COLOCATED_TEMPLATE__ from './toolbar-popup-menu-options-heading.hbs.js'; */
import Component from "@ember/component";
export default class ToolbarPopupMenuOptionsHeading extends Component {}